export default __webpack_public_path__ + "static/media/esteira.4a1e637d.png";